export enum JobBuildStatus {
    NotStarted = 0,
    Awaiting = 1,
    InProgress = 2,
    Success = 3,
    Failed = 4,
}

export function isCompletedStatus(status: JobBuildStatus) {
    const completedStatuses = [
        JobBuildStatus.Success,
        JobBuildStatus.Failed,
    ];

    return completedStatuses.includes(status);
}

export enum ClusterDeploymentStatus { // In sequential order
    RESOURCE_NOT_FOUND = -1,
    RESOURCE_PROVISIONING,
    RESOURCE_READY,
    CLUSTER_READY,
    INGRESS_READY,
    DNS_READY,
    CERT_READY,
    SERVICE_FAIL, // must be last
}

const clusterDeploymentStatusMap: Record<ClusterDeploymentStatus, string> = {
    [ClusterDeploymentStatus.RESOURCE_NOT_FOUND]: "Resource Not Found",
    [ClusterDeploymentStatus.RESOURCE_PROVISIONING]: "Resource Provisioning",
    [ClusterDeploymentStatus.RESOURCE_READY]: "Resource Ready",
    [ClusterDeploymentStatus.CLUSTER_READY]: "Cluster Ready",
    [ClusterDeploymentStatus.INGRESS_READY]: "Ingress Ready",
    [ClusterDeploymentStatus.DNS_READY]: "DNS Ready",
    [ClusterDeploymentStatus.CERT_READY]: "Cert Ready",
    [ClusterDeploymentStatus.SERVICE_FAIL]: "Service Fail",
};
const stringToClusterDeploymentStatusMap = Object.entries(
    clusterDeploymentStatusMap
).reduce((acc, [key, value]) => {
    acc[value] = Number(key);
    return acc;
}, {} as Record<string, ClusterDeploymentStatus>);

export function clusterDeploymentStatusToString(
    status: ClusterDeploymentStatus
): string {
    return clusterDeploymentStatusMap[status] ?? "Unknown Status";
}

export function stringToClusterDeploymentStatus(
    str: string
): ClusterDeploymentStatus | undefined {
    return stringToClusterDeploymentStatusMap[str];
}

export function isDeploymentCompletedStatus(status: ClusterDeploymentStatus) {
    const completedStatuses = [
        ClusterDeploymentStatus.SERVICE_FAIL,
        ClusterDeploymentStatus.CERT_READY,
        ClusterDeploymentStatus.RESOURCE_NOT_FOUND
    ];

    return completedStatuses.includes(status);
}

export function isDeploymentPendingStatus(status: ClusterDeploymentStatus) {
    const completedStatuses = [
        ClusterDeploymentStatus.RESOURCE_PROVISIONING,
        ClusterDeploymentStatus.RESOURCE_READY,
        ClusterDeploymentStatus.CLUSTER_READY,
        ClusterDeploymentStatus.INGRESS_READY,
        ClusterDeploymentStatus.DNS_READY,
    ];

    return completedStatuses.includes(status);
}